<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div class="row-col">

    <a 
      data-dismiss="modal" 
      class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
    <div class="p-a b-b">
      <span class="h5 text-capitalize">{{ presetReasonExists() ? 'Update' : 'Create' }} Preset Reason</span>
    </div>

    <div class="row-row">
      <div class="row-body">
        <div class="row-inner">
          <div class="p-a">
          
            <div 
              :class="{'invalid':errors.has('Reason')}" 
              class="md-form-group">
              <textarea
                v-validate="'required'"
                :disabled="loading"
                v-model="presetReason.reason" 
                name="Reason"
                class="md-input" 
                rows="2"/>
              <label>Reason</label>
              <span 
                v-show="errors.has('Reason')" 
                class="form-error-msg">{{ errors.first('Reason') }}</span>
            </div>

            <div class="md-form-group">
              <select 
                id="type"
                :disabled="loading" 
                v-model="presetReason.type" 
                class="md-input">
                <option 
                  v-for="type in types" 
                  :value="type.id" 
                  :key="type.id">
                  {{ type.name }}
                </option>
              </select>     
              <label for="type">Type</label>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="p-a b-t">
      <div class="text-right">
        <button 
          :disabled="loading" 
          class="md-btn md-raised w-xs white" 
          data-dismiss="modal">Cancel</button>
        <button 
          :disabled="loading || !canManageSettings" 
          class="md-btn md-raised m-l-sm w-xs green" 
          @click="submit()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '@js/plugins/auth';
import types from './types';

export default {
    props: {
        presetReason: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            types: types,
        };
    },

    methods: {
        canManageSettings() {
            return Auth.hasPermissionTo('franchise_manage_preset_reasons');
        },

        submit() {
            var that = this;
            this.loading = true;

            this.$validator.validateAll().then(result => {
                if (result) {
                    that.$http[this.getSubmitMethod()](
                        that.getPresetReasonApi(this.presetReason.id),
                        this.presetReason,
                    ).then(
                        response => {
                            if (response.status == '200') {
                                if (!that.presetReasonExists()) {
                                    that.$parent.initPresetReason();
                                } else {
                                    this.$parent.modal('hide');
                                }

                                let msg =
                                    'Preset reason has been successfully ' +
                                    (!that.presetReasonExists()
                                        ? 'created'
                                        : 'updated');
                                toastr.success(msg);
                                this.$parent.refresh();
                            }

                            this.clearErrorValidation();
                            that.loading = false;
                        },
                        error => {
                            toastr.error(error.statusText);
                            that.loading = false;
                        },
                    );
                } else {
                    that.loading = false;
                }
            });
        },

        presetReasonExists() {
            return (
                this.presetReason.id != 0 && this.presetReason.id != undefined
            );
        },

        getSubmitMethod() {
            if (this.presetReasonExists()) {
                return 'patch';
            } else {
                return 'post';
            }
        },

        getPresetReasonApi() {
            if (this.presetReasonExists()) {
                let id = this.presetReason.id;
                return Laroute.route('franchise.setting.presetreason.update', {
                    id: id,
                });
            } else {
                return Laroute.route('franchise.setting.presetreason.store');
            }
        },

        clearErrorValidation() {
            var that = this;
            setTimeout(() => {
                that.errors.clear();
            }, 50);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/presetreason/presetReasonForm.vue